import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { noTopSafeArea, useBridgeState } from '@digitaz/bridge-sdk-client';
import { useEffect } from 'react';
import { createRouterReplace } from '@/bridge/utils/navigation';

export const BridgeSafeAreaManager = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { isWebView } = useBridgeState();

  useEffect(() => {
    if (isWebView) {
      noTopSafeArea('', createRouterReplace(router));
    }
  }, [isWebView, pathname, router, searchParams]);

  return null;
};
